import { render } from "./TrainingServices.vue?vue&type=template&id=4faf472e"
import script from "./TrainingServices.vue?vue&type=script&lang=js"
export * from "./TrainingServices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ru1x89/Sites/ssi-protection/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__